import React from 'react';
import { fmt } from '../utils/api';

// Compact, glanceable summary meant to sit right under Budget Overview -
// full detail (category breakdown, transaction list, multi-year) lives in
// BigPurchasesSnapshot near Top Spenders and the dedicated Transactions tab.
export default function BigPurchasesBanner({ budget, onViewAll }) {
  const bp = budget?.bigPurchases;
  if (!bp || bp.thisYear <= 0) return null;

  return (
    <button style={styles.banner} onClick={onViewAll}>
      <span style={styles.left}>
        <span style={styles.icon}>💥</span>
        <span style={styles.label}>Big Purchases This Year</span>
      </span>
      <span style={styles.right}>
        <span style={styles.value}>{fmt.currency(bp.thisYear)}</span>
        {bp.excludedFromBudget && <span style={styles.tag}>excluded from pace</span>}
        <span style={styles.arrow}>→</span>
      </span>
    </button>
  );
}

const styles = {
  banner: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'rgba(239, 68, 68, 0.05)',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    borderRadius: '12px',
    padding: '0.75rem 1rem',
    marginBottom: '1.25rem',
    cursor: 'pointer',
  },
  left: { display: 'flex', alignItems: 'center', gap: '8px' },
  icon: { fontSize: '1rem' },
  label: {
    color: '#e5e7eb',
    fontSize: '0.8rem',
    fontWeight: '600',
    fontFamily: "'Syne', sans-serif",
  },
  right: { display: 'flex', alignItems: 'center', gap: '8px' },
  value: {
    color: '#ef4444',
    fontSize: '0.95rem',
    fontWeight: '800',
    fontFamily: "'DM Mono', monospace",
  },
  tag: {
    color: '#00d4aa',
    fontSize: '0.62rem',
    fontWeight: '600',
    fontFamily: "'Syne', sans-serif",
    border: '1px solid #00d4aa',
    borderRadius: '999px',
    padding: '2px 7px',
  },
  arrow: { color: '#4b5563', fontSize: '0.85rem' },
};
